export const data = [
    {
        name : "Frontend",
        icons : [ "html" , "css" , "javascript" , "react" , "angular" , "nextjs" ]
    },
    {
        name : "Backend",
        icons : [ "node" , "express" , "php"]
    },
    {
        name : "Databases",
        icons : ["mysql","mongodb","postgres"]
    },
    {
        name : "Tools",
        icons : [ "git" , "postman" , "uipath"]
    },
    {
        name : "Programming",
        icons : ["c","c++","java","python","typescript"]
    },
    {
        name : "ML",
        icons : ["numpy","pandas","matplotlib","scikit"]
    },
    {
        name : "Others",
        icons : ["bootstrap","jquery","tailwind","graphql"]
    },
    
]